<div class="nt-container">
  <div class="nt-full-width-loading-shade" *ngIf="isloading">
    <mat-spinner color="primary" *ngIf="isloading"></mat-spinner>
  </div>
</div>
<div class="container-fluid grid-example" style="height: 100%">
  <h2>{{ "routes.dashboard.TITLE" | translate }}!</h2>
  <div class="row" style="margin-top: 40px">
    <app-dashboardnotifications
      *ngIf="!isloading && message"
      class="col-12 mb-2"
      [notification]="message"
    ></app-dashboardnotifications>
    <div class="col-xl-3 col-md-6">
      <!-- START card-->
      <a class="link-unstyled text-primary">
        <div
          class="card flex-row align-items-center align-items-stretch border-0"
          [routerLink]="['/licenses']"
          style="cursor: pointer"
        >
          <div
            class="col-4 d-flex align-items-center bg-gray-light justify-content-center rounded-left"
          >
            <em class="icon-doc fa-3x"></em>
          </div>
          <div class="col-8 py-3 rounded-right">
            <div class="numbers-font-size mt-0 devices-status-container">
              <div
                class="green"
                tooltip="{{ 'tooltips.license.dashboard.VALID' | translate }}"
                [routerLink]="['/licenses']"
                [queryParams]="{ status: 'valid' }"
                style="cursor: pointer"
              >
                <span></span>
                {{ count.validLicemses }}
              </div>
              <div
                class="yellow"
                tooltip="{{ 'tooltips.license.dashboard.EXPIRESSOON' | translate }}"
                [routerLink]="['/licenses']"
                [queryParams]="{ status: 'expires in 10 days' }"
                style="cursor: pointer"
              >
                <span></span>
                {{ count.expiredInTenDaysLicenses }}
              </div>
              <div
                class="red"
                tooltip="{{ 'tooltips.license.dashboard.EXPIRED' | translate }}"
                [routerLink]="['/licenses']"
                [queryParams]="{ status: 'expired' }"
                style="cursor: pointer"
              >
                <span></span>
                {{ count.expiredLicenses }}
              </div>
            </div>
            <div class="text-uppercase">
              {{ "routes.dashboard.tiles.LICENSES" | translate }}
            </div>
          </div>
        </div>
      </a>
    </div>
    <div class="col-xl-3 col-md-6">
      <!-- START card-->
      <a class="link-unstyled text-primary" [routerLink]="['/resources']">
        <div
          class="card flex-row align-items-center align-items-stretch border-0"
          tourAnchor="addResource#1"
        >
          <div
            class="col-4 d-flex align-items-center bg-gray-light justify-content-center rounded-left"
          >
            <em class="icon-calendar fa-3x"></em>
          </div>
          <div class="col-8 py-3 rounded-right">
            <div class="numbers-font-size mt-0">
              {{ count.resources }}
              <!-- <small>GB</small> -->
            </div>
            <div class="text-uppercase">
              {{ "routes.dashboard.tiles.RESOURCES" | translate }}
            </div>
          </div>
        </div>
      </a>
    </div>
    <div class="col-xl-3 col-md-6">
      <!-- START card-->
      <a class="link-unstyled text-primary">
        <div
          class="card flex-row align-items-center align-items-stretch border-0"
          [routerLink]="['/devices']"
          style="cursor: pointer"
        >
          <div
            class="col-4 d-flex align-items-center bg-gray-light justify-content-center rounded-left"
          >
            <em class="icon-screen-tablet fa-3x"></em>
          </div>
          <div class="col-8 py-3 rounded-right">
            <div class="numbers-font-size mt-0 devices-status-container">
              <div
                class="online-devices"
                tooltip="{{ 'tooltips.device.ONLINE' | translate }}"
                tooltipPlacement="top"
                [routerLink]="['/devices']"
                [queryParams]="{ status: 'online' }"
                style="cursor: pointer"
              >
                <span></span>
                {{ count.onlineDevices }}
              </div>
              <div
                class="offline-devices"
                tooltip="{{ 'tooltips.device.OFFLINE' | translate }}"
                tooltipPlacement="top"
                [routerLink]="['/devices']"
                [queryParams]="{ status: 'offline' }"
                style="cursor: pointer"
              >
                <span></span>
                {{ count.offlineDevices }}
              </div>
              <!-- <small>GB</small> -->
            </div>
            <div class="text-uppercase">
              {{ "routes.dashboard.tiles.DEVICES" | translate }}
            </div>
          </div>
        </div>
      </a>
    </div>
    <div class="col-xl-3 col-lg-6 col-md-12">
      <!-- START card-->
      <a class="link-unstyled text-primary" [routerLink]="['/account/invoices']">
        <div class="card flex-row align-items-center align-items-stretch border-0">
          <div
            class="col-4 d-flex align-items-center bg-gray-light justify-content-center rounded-left"
          >
            <em class="icon-docs fa-3x"></em>
          </div>
          <div class="col-8 py-3 rounded-right">
            <div class="numbers-font-size mt-0">{{ count.invoices }}</div>
            <div class="text-uppercase">
              {{ "routes.dashboard.tiles.INVOICES" | translate }}
            </div>
          </div>
        </div>
      </a>
    </div>
    <div class="col-xl-3 col-lg-6 col-md-12">
      <!-- START date widget-->
      <!-- <div class="card flex-row align-items-center align-items-stretch border-0">
        <div class="col-4 d-flex align-items-center bg-green-dark justify-content-center rounded-left">
          <div class="text-center">

            <div class="text-sm" now format="MMMM"></div>
            <br>
            <div class="h2 mt-0" now format="D"></div>
          </div>
        </div>
        <div class="col-8 py-3 rounded-right">
          <div class="text-uppercase" now format="dddd"></div>
          <br>
          <div class="h2 mt-0" now format="HH:mm"></div>
        </div>
      </div> -->
      <!-- END date widget-->
    </div>
  </div>
  <h4 style="margin-top: 50px" class="text-muted">
    {{ "routes.dashboard.SUBTITLE" | translate }}
  </h4>
  <div class="row justify-content-center" style="margin-top: 50px">
    <div *ngIf="false" class="col-xl-3 col-md-6">
      <a class="link-unstyled text-primary" [routerLink]="['/devices']">
        <div class="card b">
          <div class="card-body text-center">
            <em class="fa-3x fas icon-screen-tablet mb-3"></em>
            <br />
            <span class="h4">{{ "routes.dashboard.tiles.DEVICES" | translate }}</span>
            <br />
            <div class="text-sm text-muted">
              {{ "routes.dashboard.VIEW" | translate }}
            </div>
          </div>
        </div>
      </a>
    </div>

    <div class="col-xl-6 col-md-6">
      <app-simple-update-notification-table></app-simple-update-notification-table>
    </div>

    <div class="col-xl-3 col-md-6">
      <a class="link-unstyled text-primary" [routerLink]="['/shop']">
        <div class="card b">
          <div class="card-body text-center">
            <em class="fa-3x fas icon-basket mb-3"></em>
            <br />
            <span class="h4">{{ "routes.dashboard.tiles.SHOP" | translate }}</span>
            <br />
            <div class="text-sm text-muted">
              {{ "routes.dashboard.VIEW" | translate }}
            </div>
          </div>
        </div>
      </a>
    </div>
    <div class="col-xl-3 col-md-6">
      <a
        class="link-unstyled text-primary"
        href="https://docs.hxa.io"
        rel="noopener"
        target="_blank"
      >
        <div class="card b">
          <div class="card-body text-center">
            <em class="fa-3x fas icon-question mb-3"></em>
            <br />
            <span class="h4">{{ "routes.dashboard.tiles.FAQ" | translate }}</span>
            <br />
            <div class="text-sm text-muted">
              {{ "routes.dashboard.VIEW" | translate }}
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
  <!-- <div class="row justify-content-center" style="margin-top: 150px">
    <div class="col-4">
      <div class="card">
        <div class="card-body text-center">
          <h4 class="text-center mb mt">{{ 'routes.dashboard.BETATEXT' | translate }}</h4>
          <p class="mb-3">{{ 'routes.dashboard.BETADESCRIPTION' | translate }}</p>
          <a href="https://www.hxa.io/kontakt/" target="_blank"><button class="btn btn-info" type="button">{{ 'routes.dashboard.CONTACT' | translate }}</button></a>
        </div>
      </div>
    </div>
  </div> -->
</div>
